
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ocean-ev-charger/specs",
      function () {
        return require("private-next-pages/ocean-ev-charger/specs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ocean-ev-charger/specs"])
      });
    }
  